const hash53bit = (str, seed = 0) => {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16);
}

angular.module('lazyLoad', [])
    .provider('lazyLoad', function ($controllerProvider) {
        const registeredControllers = new Set();

        function create(component, obj = {}) {
            const { name, templateUrl, controller } = component
            const hashController = hash53bit(controller.toString())
            const controllerName = `${name}Ctrl-${hashController}`

            obj.controller = controllerName
            obj.templateUrl = templateUrl

            obj.resolve ??= {}
            obj.resolve.controllerProvider = async () => {
                if (registeredControllers.has(controllerName))
                    return;

                const controllerModule = await controller();
                if (!controllerModule.default) {
                    throw new Error(
                        `Controller "${controllerName}" has no default export`
                    );
                }

                $controllerProvider.register(controllerName, controllerModule.default);
                registeredControllers.add(controllerName)
            }

            return obj;
        }

        this.create = create;
        this.$get = function () {
            return {
                create
            };
        };
    });